import { Link } from "react-router-dom";
import { articles } from "@/mocks/news";
import { formatDate, getMovieTitle } from "@/lib/content";

const ordered = [...articles].sort((a, b) => b.date.localeCompare(a.date));
const lead = ordered[0];
const rest = ordered.slice(1, 6);

export default function NewsHighlights() {
  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 font-label text-[12px] uppercase tracking-[0.24em] text-primary-600">
              <span className="inline-block h-[1px] w-6 bg-accent-500"></span>
              影评与资讯
            </p>
            <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
              编辑部最近在读什么
            </h2>
          </div>
          <Link
            to="/news"
            className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 md:self-auto"
          >
            全部影评资讯
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <article className="group lg:col-span-5">
            <Link to={`/news/${lead.id}`} className="block">
              <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg bg-secondary-200">
                <img
                  src={lead.cover}
                  alt={`${lead.title} 配图`}
                  title={`${lead.title} - 80s电影`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                  <span className="rounded-full bg-accent-500 px-2.5 py-1 font-label text-[11px] tracking-widest text-primary-950">
                    {lead.type}
                  </span>
                  <h3 className="mt-3 font-heading text-xl font-semibold leading-snug text-background-50 md:text-2xl">
                    {lead.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-background-200/85 md:text-sm">
                    {lead.excerpt}
                  </p>
                </div>
              </div>
            </Link>
            <div className="mt-3 flex flex-wrap items-center gap-2 text-[11px] text-secondary-600">
              <span>{formatDate(lead.date)}</span>
              <span className="text-secondary-400">·</span>
              <span>{lead.author}</span>
              {lead.movieId && (
                <>
                  <span className="text-secondary-400">·</span>
                  <Link to={`/movie/${lead.movieId}`} className="text-primary-700 hover:underline">
                    {getMovieTitle(lead.movieId)}
                  </Link>
                </>
              )}
            </div>
          </article>

          <div className="lg:col-span-7">
            <ul className="flex flex-col divide-y divide-background-300/70 border-t border-background-300/70">
              {rest.map((article, index) => (
                <li key={article.id}>
                  <Link
                    to={`/news/${article.id}`}
                    className="group flex items-start gap-4 py-4 transition-colors md:gap-5 md:py-5"
                  >
                    <span className="mt-0.5 font-label text-2xl font-medium leading-none text-background-500 md:text-3xl">
                      {String(index + 2).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2 text-[11px] text-secondary-600">
                        <span className="rounded-sm bg-primary-100 px-1.5 py-0.5 text-primary-700">
                          {article.type}
                        </span>
                        <span>{formatDate(article.date)}</span>
                      </div>
                      <h3 className="mt-1.5 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                        {article.title}
                      </h3>
                      <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{article.excerpt}</p>
                    </div>
                    <i className="ri-arrow-right-up-line mt-1 text-secondary-400 transition-colors group-hover:text-primary-600"></i>
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to="/news"
              className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-primary-600"
            >
              浏览更多文章
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}